import {Pipe, PipeTransform} from '@angular/core';
import MiscUtil from '../utils/misc.util';

@Pipe({name: 'urlSafe'})
export class UrlSafePipe implements PipeTransform {
    transform(value: string): string {
        return MiscUtil.fixedEncodeURIComponent(value);
    }
}
